import React, { Component } from "react";
import { Icon } from "design-react-kit";

export class MInputFile extends Component {
  /**
   * PROPS:
   * id       : identifier
   * name     : name of the field
   * label    : example text (brief description of fields)
   * accept   : allowed file extensions (e.g. ".xlsx, .csv")
   * infoText : addtional text used when the input in invalid
   * disabled : insert for readonly
   * readOnly : is readOnly
   * valid    : set  when the input is valid
   * invalid  : set  when the input is invalid
   */

  onChange = (event) => {
    const file = event.target.files[0] || null;

    if (this.props.onChange) {
      this.props.onChange(this.props.name, file);
    }
  };

  render() {
    const { id, name, disabled = false, readOnly = false, invalid, label, infoText, config = {}, value } = this.props;

    const currentFile = value && value.value ? value.value : value;
    const fileName = currentFile && currentFile.name ? currentFile.name : null;

    return (
      <div className={`form-group ${this.props.className || ""}`}>
        {label && (
          <h6 className="my-4" htmlFor={id}>
            {label}
          </h6>
        )}

        <div className="wrapperUploadBtn mb-2">
          <input
            id={id}
            name={name}
            className="uploadFormFile"
            type="file"
            accept={config.accept}
            onChange={this.onChange}
            style={{ display: "none" }}
            ref={(input) => (this.fileInput = input)}
            disabled={disabled || readOnly}
          />

          <button type="button" className={`btn btn-primary bg-dark`} onClick={() => this.fileInput.click()} disabled={disabled || readOnly}>
            <Icon icon="it-upload" size="sm" className="icon-white mr-2" aria-hidden="true" />
            {config.btnLabel || "Carica file"}
          </button>

          {!fileName && (
            <div className="mt-2 d-flex flex-column justify-content-center align-items-center">
              {config.accept && (
                <span className="text-muted mt-2">
                  Estensioni consentite: <strong>{config.accept}</strong>
                </span>
              )}

              {config.sampleFileUrl && (
                <a href={config.sampleFileUrl} download className="text-primary font-weight-bold d-flex align-items-center">
                  File di esempio
                </a>
              )}
            </div>
          )}

          {fileName && <p className="uploadFileName">{fileName}</p>}
        </div>

        {invalid && !fileName && <div className="form-text text-danger">{infoText}</div>}
      </div>
    );
  }
}
